<template>
    <div class="game-view">
        <div v-if="!playerId">
            <GameLobby :game-id="gameId" />
        </div>
        <div v-else>
            <GameBoard :game-state="gameState" :player-id="playerId" />
        </div>
    </div>
</template>

<script>
import { computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useGameStore } from '@/stores/game'
import GameLobby from '@/components/GameLobby.vue'
import GameBoard from '@/components/GameBoard.vue'

export default {
    components: { GameLobby, GameBoard },
    props: {
        id: String
    },
    setup(props) {
        const route = useRoute()
        const gameStore = useGameStore()
        
        const gameId = computed(() => props.id || route.params.id)
        const playerId = computed(() => gameStore.playerId)
        const gameState = computed(() => gameStore.gameState)

        // 轮询游戏状态
        let pollInterval = null
        
        const startPolling = () => {
            if (pollInterval) clearInterval(pollInterval)
            pollInterval = setInterval(() => {
                if (gameId.value) {
                    gameStore.fetchGameState()
                }
            }, 2000)
        }
        
        onMounted(() => {
            if (gameId.value) {
                gameStore.fetchGameState()
                startPolling()
            }
        })
        
        watch(gameId, (newVal) => {
            if (newVal) {
                gameStore.fetchGameState()
                startPolling()
            } else {
                if (pollInterval) clearInterval(pollInterval)
            }
        })
        
        return {
            gameId,
            playerId,
            gameState
        }
    }
}
</script>

<style scoped>
.game-view {
    padding: 20px;
}
</style>